import { ResultsBox } from '../../../../../../tools/SearchPage/Search.styles';
import { Table } from '../../../../../../common/tableElements';
import SearchResultList from '../../../../../../tools/SearchPage/SearchResultList';
import * as searchTypes from '../../../../../../../constants/searchTypes';
import React from 'react';
import { Loader } from '../../../../../../../components/common/Loader/Loader';
import { ResultsTable, ResultsHeader } from '../../../DTOrderSearch.styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  getIsZendeskShopSelected,
  getOrderingSystem,
  getOrdersSearchProperties,
} from '../../../../../../../selectors/tools';
import { selectLoading } from '../../../../../../../selectors/fetchOrder';
import { fetchAmazonOrder } from '../../../../../../../actions/tools/FetchOrderActions';

const SearchResultsAmazon = () => {
  const isZendeskShopSelected = useSelector(getIsZendeskShopSelected);
  const ordersSearch = useSelector(getOrdersSearchProperties);
  const orderingSystem = useSelector(getOrderingSystem);
  const isLoading = useSelector(selectLoading);
  const dispatch = useDispatch();

  const zendeskConfig = {
    isZendesk: isZendeskShopSelected,
    returnUrl: (ordersSearch.selectedConfig || {}).returnUrl || '',
    customMessage: (ordersSearch.selectedConfig || {}).customMessage || '',
  };

  const resultClickAction = (event, order) => {
    event.preventDefault();
    dispatch(fetchAmazonOrder(order));
  };

  return (
    <ResultsBox key="orderResults">
      <ResultsHeader style={{ paddingLeft: '30px' }} hide={!ordersSearch.orders.length}>
        Please select the order
      </ResultsHeader>
      <ResultsTable className="table table-hover results-table">
        <Loader visible={isLoading}>
          <Table>
            <SearchResultList
              listType={searchTypes.SEARCH_ORDERS}
              resultList={ordersSearch.orders}
              resultClickAction={resultClickAction}
              zendeskConfig={zendeskConfig}
              orderingSystem={orderingSystem}
            />
          </Table>
        </Loader>
      </ResultsTable>
    </ResultsBox>
  );
};

export default SearchResultsAmazon;
